import React from "react";
import { Card, Select, Input, Typography, Row, Col } from "antd";

const OfferStatusSection = ({
  statuts,
  selectedStatus,
  setSelectedStatus,
  offer_status_description,
  setOfferStatusDescription,
}) => {
  return (
    <Card 
      id="offer-status-section"
      style={{ width: '100%' }}
      title={<Typography.Title level={5}>Offer Status</Typography.Title>}
    >
      <Row gutter={16}>
        <Col md={8}>
          <div style={{ marginBottom: 8 }}>
            <Typography.Text strong>Status</Typography.Text>
          </div>
          <Select
            style={{ width: '100%' }}
            options={statuts.map(option => ({
              label: option.label,
              value: option.value
            }))}
            value={selectedStatus ? selectedStatus.value : undefined}
            onChange={(value) => {
              const selectedOption = statuts.find(opt => opt.value === value);
              setSelectedStatus(selectedOption);
            }}
            placeholder="Select Status"
          />
        </Col>

        <Col md={16}>
          <div style={{ marginBottom: 8 }}>
            <Typography.Text strong>Offer Status Description</Typography.Text>
          </div>
          <Input.TextArea
            value={offer_status_description}
            rows={4}
            onChange={(e) => setOfferStatusDescription(e.target.value)}
            placeholder="Enter status details"
          />
        </Col>
      </Row>
    </Card>
  );
};

export default OfferStatusSection;
